import * as Yup from "yup";

const servicoSchema = Yup.object().shape({
  servicoId: Yup.number().required("Serviço"),
  quantidade: Yup.number()
    .positive("Quantidade deve ser maior que 0")
    .required("Quantidade"),
  valor: Yup.number()
    .positive("Valor do serviço deve ser maior que 0")
    .required("Valor do serviço"),
  descricao: Yup.string().required("Descrição do serviço"),
  classificacaoServicoNacional: Yup.string().required(
    "Classificação do serviço",
  ),
  codigoServicoNacional: Yup.string().required("Código do serviço"),
  aliquotaTotalSimplesNacional: Yup.number().required(
    "Alíquota do Simples Nacional",
  ),
  fatOrdemServicoId: Yup.number().optional(),
  grupoTributarioId: Yup.number().optional(),
});

export default servicoSchema;
